import React from 'react';
import loadable from '@loadable/component';
import { LoadingPage } from 'components/core/LoadingPage';
import { useTrackedDecision } from 'lib/optimizelyDebug';
import { OPTIMIZELY_FLAGS } from 'config/optimizely';

const options = {
	fallback: <LoadingPage />,
};

const FacilityPageV2 = loadable(
	() =>
		import(
			/* webpackChunkName: "FacilityPageV2" */ '../FacilityPageV2/FacilityPageV2'
		),
	options,
);

export default function FacilityPageWrapper(props) {
	// A/A test: bucket users for reporting verification (no UI change). Placed in
	// the wrapper rather than in FacilityPageV2 so the impression is recorded on
	// page view instead of waiting on the code-split chunk to resolve.
	//
	// useTrackedDecision over useDecision so the decision also lands in
	// window.__OPTIMIZELY_DEBUG__, which is what QA reads to verify bucketing.
	useTrackedDecision(OPTIMIZELY_FLAGS.FACILITY_PAGE_AA_TEST);

	return <FacilityPageV2 {...props} />;
}
